<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="true"
    custom-class="list-dialog">
    <div style="width: 100%">
      <div class="contentTable" v-for="(item,index) in order">
        <div class="head">
          <p class="fl marginR-30 marginL-20">
            <label class="color-grey">{{item.htqd||item.adddate}}</label>
          </p>
          <p class="fl marginR-30 alignleft">
            <!--<span class="color-grey ddNum "></span>-->
            <span class="marginR-30 erpserial1 ">{{item.erpserial}}</span>
            <a href="javascript:void(0);" style="display: inline-block;" @mouseenter="show1(item)"
               @mouseleave="hide1(item)">
              <span class="ellipsis">下单人：{{item.uname}}</span>
              <span class="tip " > <img class="iphone_icon" src="/static/img/iphone_icon.jpg"/>
                <!--提示框-->
                <div class="sub-nav" v-show="item.isShow">
                  <div class="Tipcontent">
                    <ul>
                      <li>联系人：{{item.linkman}}</li>
                      <li>联系电话：{{item.linkmantel}}</li>
                      <li>收货地址：{{item.deliveryaddress}}</li>
                      <li>收货方式：{{item.deliverymode||""}}</li>
                    </ul>
                  </div>
                  <s><i></i></s>
                </div>
                <!--提示框 end-->
              </span>
            </a>
          </p>
        </div>
        <!--head end-->
        <table class="mainTable">
          <tr>
            <td class="width_560"
                :style="picture(item)"
                rowspan="2">
              <div v-for="(item1,index1) in item.jxcformdetailDOList"
                   :style="{height:'70px',paddingTop: '5px',paddingBottom: '5px',borderTop:index1>0?'1px solid #EEEEEE':'none'}">
                <img style="width:70px;height:70px;margin-left: 10px;" :src="item1.imageUrl||''"
                     @error="imgError"/>
                <p class="alignleft">
                  <span class="cp_title">{{item1.seedname}}</span>
                  <span>x {{item1.totalnumber||0}}</span>
                </p>
              </div>
              <div v-if="item.orderfill == '8099'&&!item.jxcformdetailDOList" style="margin-left: 90px" v-html="getbuyLiuYan(item)"></div>
            </td>
            <!--<td class="width_200 textCenter" style="vertical-align: middle;height: 56px" rowspan="2">-->
              <!--<div style="">-->
                <!--<p style="">-->
                  <!--<span class="numtitle textR">金额：</span>-->
                  <!--<span class="numbody textL" v-if="showlookprice">￥{{( (item.htje||0)+(item.discount||0) ) | numeric(2)}}</span>-->
                  <!--<span class="numbody textL" v-else>???</span>-->
                <!--</p>-->
                <!--<p style="">-->
                  <!--<span class="numtitle textR">运费：</span>-->
                  <!--<span class="numbody textL">￥{{(item.expressfee||0)|numeric(2)}}</span>-->
                <!--</p>-->
                <!--<p style="">-->
                  <!--<span class="numtitle textR">折扣：</span>-->
                  <!--<span class="numbody textL" v-if="showlookprice">￥{{(item.discount||0)|numeric(2)}}</span>-->
                  <!--<span class="numbody textL" v-else>???</span>-->
                <!--</p>-->
                <!--<p style="">-->
                  <!--<span class="numtitle textR">实收：</span>-->
                  <!--<span class="numbody textL">-->
                        <!--<span v-if="showlookprice">￥{{(item.yfk||0)|numeric(2)}}</span>-->
                        <!--<span v-else>???</span>-->
                      <!--<span class="color-yellow">{{item.status=='700'||item.status=='660'||item.status=='655'||item.status=='650'?'待退款':item.status=='750'?'已退款': "" }} </span></span>-->
                <!--</p>-->
                <!--<p class="color-yellow">{{(item.status=='810'||item.status=='820')?"按合同结算":(item.paymethod||'')}}</p>-->
              <!--</div>-->
            <!--</td>-->
            <td rowspan="2" class="width_200 textCenter btnBox">
              <div v-if="!(item.status=='500'||item.status=='400'||item.status=='750')" >
                <b>{{getStatusName(item)}}</b>
              </div>
              <div v-if="item.status=='500'||item.status=='400'" style="text-align: left;">
                <span style="margin-left: 10px;">发货时间：{{item.handleoverdate}}</span>
                <i style="display: block;height: 5px"></i>
                <span style="margin-left: 10px;">物流公司：{{item.logisticsco}}</span>
                <i style="display: block;height: 5px"></i>
                <span style="margin-left: 10px;">物流单号：{{item.logisticsnum}}</span>
              </div>
              <div v-if="item.status=='750'" style="text-align: left;">
                <span style="margin-left: 10px;">退款时间：{{item.handleoverdate}}</span>
                <i style="display: block;height: 5px"></i>
                <span style="margin-left: 10px;">操&nbsp;作&nbsp;&nbsp;人：{{item.handleoveruname}}</span>
                <i style="display: block;height: 5px"></i>
              </div>
              <button @click="lookDetails(item)">查看订单</button>
              <button @click="backOrder(item)"  class="removeButton" v-if="item.issh != 1&&!(item.status=='700'||item.status=='660'||item.status=='655'||item.status=='650'||item.status=='750')">{{item.status==100?'取消订单':'申请退货'}}</button>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <BuyfromSupplyer ref="BuyfromSupplyer" @afterClose="afterLogin"></BuyfromSupplyer>
  </el-dialog>
</template>

<script>
    import {getBySerial} from '@/api/set/externaldept';
    import {login, listOrder,backOrder} from '@/api/ossi';
    import BuyfromSupplyer from './BuyfromSupplyer';
    import { getRemark} from '@/plugin/ordercommon'

    export default {
      name: "BuyfromList",
      data() {
        return {
          title: '订单信息',
          showlookprice:true,
          dialogSeeVisible: false,
          ssotoken: '',
          website: '',
          erpserial: '',
          pcustomerserial: '',
          userInfoModel: [],
          order: [],
          statusobj: [{value: "100", text: "待支付"},{value: "200", text: "待确认"}, {value: "300", text: "待加工"}, {value: "350", text: "待发货"},
            {value: "500", text: "已发货"}, {value: "700", text: "待退款"}, {value: "750", text: "退款完成"},
            {value: "400", text: "待配送"}, {value: "150", text: "待选货"}, {value: "650", text: "退货客服岗待确认"},
            {value: "655", text: "退货订单岗待确认"}, {value: "660", text: "退货仓库岗待确认"}],
        }
      },
      methods: {
        lookDetails(item) {
          this.$refs.BuyfromSupplyer.show(this.ssotoken,this.website,item,'detail');
        },
        backOrder(item) {
          if (item.status == 100) {
            this.$confirm('是否确定取消订单?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

              backOrder({erpserial:item.erpserial}, this.ssotoken).then(resDel =>{
                this.afterLogin();
              });

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });

          } else {
            this.$refs.BuyfromSupplyer.show(this.ssotoken, this.website, item, 'back');
          }
        },
        show(erpserial, pcustomerserial) {
          if (erpserial && erpserial.length >= 14 && erpserial.substr(0, 2) == 42) {

            this.erpserial = erpserial;
            this.pcustomerserial = pcustomerserial;
            getBySerial({customerserial: this.pcustomerserial, unitgroup: '3'}).then(resCus => {
              if (resCus.data.code == 0 && resCus.data.obj.usesso == '1' && resCus.data.obj.ssocode) {
                this.dialogSeeVisible = true;
                login({idencode: resCus.data.obj.ssocode, tenantid: this.userInfoModel.tenantid,independentserial: this.userInfoModel.independentserial}).then(loginres => {
                  if (loginres.data.code == 0) {
                    this.ssotoken = loginres.data.msg;
                    this.website = loginres.data.website;
                    this.afterLogin();
                  } else {
                    this.$message({message: loginres.data.msg, type: 'error'})
                  }
                });
              }
            });
          }
        },
        getbuyLiuYan(item) {
          if (item.orderfill && item.orderfill == '8099'&&!item.jxcformdetailDOList) {
            var pingpainame=item.pname;
            if(item.pname&&item.pname.indexOf(';')>-1){
              var pingpaicode=item.pname.split(';')[0];
              pingpainame=item.pname.replace(pingpaicode+';','');

              if(pingpaicode.startsWith('004')) pingpainame+=" 老花镜";
              else if(pingpaicode.startsWith('003')) pingpainame+=" 太阳镜";
              else pingpainame+=" 镜架";
            }
            var rH = "【"+pingpainame + "】" + getRemark(item.remark, null, '采购需求');//只显示采购留言
            if (item.seedinfo) {
              try {
                var seedlist = JSON.parse(item.seedinfo);
                if (seedlist.length > 0) {
                  rH += "<br>";
                  for (let i in seedlist) {
                    var goods = seedlist[i];
                    rH += goods.M + "-" + goods.C + " * " + goods.P + "、";
                  }
                  rH = rH.substr(0, rH.length - 1);
                }
              } catch (ex) {
              }
            }
            return rH;
          }
          return '';
        },
        afterLogin() {
          this.order=[];
          listOrder({erpserial: this.erpserial},this.ssotoken).then(resOrder => {
            if (resOrder.data.code == 0) {
              this.order = resOrder.data.obj.rows;

              for (let i in this.order) {
                this.$set(this.order[i], "isShow", false)
              }
              //console.log(this.order)
            }
          });
        },
        picture(item) {
          if (item.issh == 1) {
            return {
              paddingRight: '0px',
              paddingLeft: '0px',
              background: item.issh == 1 ? 'url(/static/img/tuihuotip.png) no-repeat right center' : ''
            }
          } else if (item.isjiaji == 1) {
            return {
              paddingRight: '0px',
              paddingLeft: '0px',
              background: item.isjiaji == 1 ? 'url(/static/img/jiajitip.png) no-repeat right center' : ''
            }
          }
        },
        show1: function (item) {
          item.isShow = true
        },
        hide1: function (item) {
          item.isShow = false
        },
        getStatusName(item) {
          for (let i in this.statusobj) {
            if (this.statusobj[i].value == item.status) {
              return this.statusobj[i].text
            }
          }
          return ""
        },
      },
      mounted() {
        this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      },
      components:{
        BuyfromSupplyer
      }
    }
</script>

<style scoped>

  @import '../../../../static/css/clear.css';
  @import '../../../../static/css/index.css';

</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyfromList.vue